var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('ul',[_c('li',[_c('a',{attrs:{"href":"/news"}},[_vm._v("最新情報")])]),_c('li',[_c('a',{attrs:{"href":"/item"}},[_vm._v("商品")])]),_c('li',[_c('a',{attrs:{"href":"/sales-place"}},[_vm._v("販売場所")])]),_c('li',[_c('a',{attrs:{"href":"/company"}},[_vm._v("会社概要")])])])])
}]

export { render, staticRenderFns }